import React from "react";
import PropTypes from "prop-types";
// import { Switch, Route } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import AuthNavbar from "./components/Navbar/AuthNavbar.jsx";
import Footer from "./components/Footer/AuthFooter.jsx";

// import routes from "routes.js";

import pagesStyle from "./authStyle.jsx";

// import register from "images/register.jpeg";
import login from "images/bg-1.jpg";

// const switchRoutes = (
//   <Switch>
//     {routes.map((prop, key) => {
//       if (prop.layout === "/auth") {
//         return (
//           <Route
//             path={prop.layout + prop.path}
//             component={prop.component}
//             key={key}
//           />
//         );
//       }
//       return null;
//     })}
//   </Switch>
// );

class Auth extends React.Component {

  // constructor(props) {
  //   super(props);
  //
  // }

  componentDidMount() {
    document.body.style.overflow = "unset";
  }

  // getActiveRoute = routes => {
  //   let activeRoute = "Default Brand Text";
  //   for (let i = 0; i < routes.length; i++) {
  //     if (
  //       window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
  //     ) {
  //       return routes[i].name;
  //     }
  //   }
  //   return activeRoute;
  // };

  // <AuthNavbar brandText="Login" />

  render() {
    const { children } = this.props;
    const { classes, ...rest } = this.props;
    return (
      <div>
        <AuthNavbar brandText="TorusRed | Login"/>
        <div className={classes.wrapper}>
          <div
            className={classes.fullPage}
            style={{ backgroundImage: `url(${login})` }}
          >
            {children}
            <Footer white />
          </div>
        </div>
      </div>
    );
  }
}

Auth.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired
};

export default withStyles(pagesStyle)(Auth);
